import clsx from "clsx"
import { Link } from "react-router-dom"
import { useLayout, usePageData } from "../../../core"

const PageTitle = () => {
     const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
     const { config, classes } = useLayout()
     const appPageTitleDirection = config.app?.pageTitle?.direction

     return (
          <div
               id="kt_page_title"
               data-kt-swapper="true"
               data-kt-swapper-mode="prepend"
               data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
               className={clsx("page-title d-flex flex-wrap me-3", classes.pageTitle.join(" "), config.app?.pageTitle?.class, {
                    "flex-column justify-content-center": appPageTitleDirection === "column",
                    "align-items-center": appPageTitleDirection !== "column",
               })}
          >
               {/* begin::Title */}
               {config.app?.pageTitle?.display && pageTitle && (
                    <h1
                         className={clsx("page-heading d-flex text-dark fw-bolder fs-2 flex-column justify-content-center my-0", {
                              "me-5": appPageTitleDirection === "row",
                         })}
                    >
                         {pageTitle}
                         {pageDescription && config.app?.pageTitle && config.app?.pageTitle?.description && (
                              <span className="page-desc text-muted fs-7 fw-semibold pt-1">{pageDescription}</span>
                         )}
                    </h1>
               )}
               {/* end::Title */}

               {/* begin::Breadcrumb */}
               {pageBreadcrumbs && pageBreadcrumbs.length > 0 && config.app?.pageTitle && config.app?.pageTitle?.breadCrumb && (
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                         {/* Optional: Home Icon at the start */}
                         <li className="breadcrumb-item">
                              <Link to="/" className="text-muted text-hover-primary">
                                   <i className="fas fa-home text-muted fs-6"></i>
                              </Link>
                         </li>

                         {Array.from(pageBreadcrumbs).map((item, index) => (
                              <li className={clsx("breadcrumb-item")} key={`${item.path}${index}`}>
                                   <span className="bullet bg-gray-300 w-5px h-2px me-2"></span>
                                   {item.path ? (
                                        <Link className="text-muted text-hover-primary" to={item.path}>
                                             {item.title}
                                        </Link>
                                   ) : (
                                        <span className="text-muted">{item.title}</span>
                                   )}
                              </li>
                         ))}

                         {/* The Active Page (Last Item) - FIXED HERE */}
                         {/* Only render this block if pageTitle exists to avoid a dangling separator */}
                         {pageTitle && (
                              <li className="breadcrumb-item">
                                   <span className="bullet bg-gray-300 w-5px h-2px me-2"></span>
                                   <span className="text-gray-900 fw-bold">{pageTitle}</span>
                              </li>
                         )}
                    </ul>
               )}
               {/* end::Breadcrumb */}
          </div>
     )
}

export { PageTitle }
